import { createSignal } from "solid-js";
import { Text } from "@gui/components";
import * as styles from "./css/VersionInfo.module.css";
const VersionInfo = () => {
    const [version] = createSignal(process.env.VERSION || "development");
    return <Text class={styles.version}>Version: {version()}</Text>;
};
export { VersionInfo };
